// React
import React from "react";
import FlexContainer from "common/ui/containers/flexContainer/FlexContainer";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./PageTabs.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class PageTabs extends React.Component {
    render() {
        return (React.createElement(FlexContainer, { className: styles.tabbleShadow },
            React.createElement("div", { className: "tabbable-line" },
                React.createElement("ul", { className: "nav nav-tabs" }, this.props.children))));
    }
}
